import { render, staticRenderFns } from "./ReviewTargetSetting.vue?vue&type=template&id=4ee17bde&scoped=true"
import script from "./ReviewTargetSetting.vue?vue&type=script&lang=js"
export * from "./ReviewTargetSetting.vue?vue&type=script&lang=js"
import style0 from "./ReviewTargetSetting.vue?vue&type=style&index=0&id=4ee17bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee17bde",
  null
  
)

export default component.exports